module.exports = __webpack_public_path__ + "img/logo.d40dd48.svg";